import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { getProvincias, deleteProvincia } from "../../../../api/provincia";
import {
  Button,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import { getCountries } from "../../../../api/country";
import { shallowEqual, useSelector } from "react-redux";
import FiltersCard from "../../../components/filters/Filter";

function getEmptyListCountries() {
  return [
    {
      _id: "",
      name: ""
    }
  ]
}


export default function ProvincePage() {
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [data, setData] = useState([])
  const [provinceId, setProvinceId] = useState(null);
  const [countries, setCountries] = useState(getEmptyListCountries());

  // const [collapsed, setCollapsed] = useState(true);
  // const [filteredData, setFilteredData] = useState([]);


  function buttonFormatter(cell) {
    const elem = data.find((item) => item.id === cell);
    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-province/" + elem.id)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {user?.role === "admin" && (
          <>
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setProvinceId(cell);
                  setOpenConfirmDialog(true);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }


  const columns = [
    { dataField: "name", text: "Province", sort: true },
    { dataField: "pais", text: "Country", sort: true },
    {
      dataField: "createdAt",
      text: "Created At",
      formatter: dateFormatter,
      sort: true,
    },
    {
      dataField: "id",
      text: "",
      formatter: buttonFormatter,
    },
  ];


  useEffect(() => {
    Promise.all([getCountries(), getProvincias()])
      .then(([countriesRes, provinciasRes]) => {
        setCountries(countriesRes.data);
        const result = provinciasRes.data.map(province => ({
          name: province.fullName,
          pais: countriesRes.data.find(item => item._id === province.pais)?.name,
          createdAt: province.createdAt,
          id: province._id
        }));
        setData(result);
        setRefresh(false);
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Error fetching countries or provinces.",
        });
      });
  }, [refresh]);


  /*const handleSearch = async () => {
    if (!data.length)
      return;
    setFilteredData(
      data.filter((item) => {
        let filter = true;
        if (filterOptions.pais && filterOptions.pais.length)
          filter = filter && filterOptions.pais.includes(item.pais);
        if (filter)
          return item;
        return false;
      })
    );
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setRefresh(true);
  };

  const handleChange = (element) => (event) => {
    setFilterOptions({ ...filterOptions, [element]: event.target.value });
  };

  const renderFiltersContent = () => {
    return (
      <>
        <br />
        <FormControl style={{ width: "100%" }}>
          <InputLabel id="demo-simple-select-standard-label">Pais</InputLabel>
          <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            value={filterOptions.pais || ""}
            multiple
            onChange={handleChange("pais")}
            MenuProps={MenuProps}
          >
            {paises?.map((option) => (
              <MenuItem key={option._id} value={option._id}>
                {option.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <br />
        <br />
      </>
    );
  };*/


  return (
    <>
      <Card>
        <CardHeader title="Province list">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary text-white"
              onClick={() => history.push("/edit-province")}
            >
              Add new
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          {/*<FiltersCard
            filtersContent={renderFiltersContent}
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            handleClearFilters={handleClearFilters}
            handleSearch={handleSearch}
          />*/}

          <Table data={data} columns={columns} />

          <ConfirmDialog
            title={"Are you sure you want to delete this province?"}
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteProvincia(provinceId)
                .then((res) => {
                  alertSuccess({
                    title: "Deleted!",
                    customMessage: "Province deleted successfully",
                  });
                  setRefresh(true);

                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not delete the province.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
